import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncNativeAnalyticsConsent, trackNativeEvent } from '../services/NativeAnalytics';
import { isNative } from '../utils/platform';
export default function NativeAnalyticsBridge() {
  const { pathname } = useLocation();
  useEffect(() => { void syncNativeAnalyticsConsent(); }, []);
  useEffect(() => {
    if (!isNative()) return;
    const screen = ({ '/dashboard': 'overview', '/activity': 'activity', '/plan': 'plan',
      '/account': 'account', '/onboarding': 'onboarding', '/login': 'login' } as Record<string,string>)[pathname];
    if (!screen) return;
    const track = () => { void trackNativeEvent('screen_view', { screen_name: screen }); };
    track();
    window.addEventListener('finflow:app-analytics-consent', track);
    return () => window.removeEventListener('finflow:app-analytics-consent', track);
  }, [pathname]);
  return null;
}
